import styled from '@emotion/styled';
import * as React from 'react';
import { useLayoutEffect, useRef } from 'react';
import { TableOfContentsItem, TableOfContentsWidget } from '../TableOfContentsWidget';
import { PAGE_LAYOUT_GAP } from '../../vars';
import { LayoutClassName } from './LayoutClassName';
import { PageWidget } from './PageWidget';
import { ReadingLayoutWidget } from './ReadingLayoutWidget';

const SIDEBAR_WIDTH = 280;

export interface TOCPageWidgetProps {
  width?: number;
  contentWidth?: number;
  center?: boolean;
  title: string;
  tableOfContents: TableOfContentsItem[];
  showHeadingTags?: boolean;
}

export const TOCPageWidget: React.FC<React.PropsWithChildren<TOCPageWidgetProps>> = (props) => {
  const { width, contentWidth, center, title, children, tableOfContents, showHeadingTags = false} = props;
  const hasTableOfContents = tableOfContents?.length > 0;
  const pageWidth = contentWidth ? contentWidth + (hasTableOfContents ? SIDEBAR_WIDTH + PAGE_LAYOUT_GAP : 0) : width;
  const layoutContentWidth =
    contentWidth ?? (pageWidth ? pageWidth - (hasTableOfContents ? SIDEBAR_WIDTH + PAGE_LAYOUT_GAP : 0) : 900);
  const contentRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    scrollContainerRef.current = document.querySelector<HTMLElement>(`.${LayoutClassName.SCROLL_CONTAINER}`);
  }, []);

  return (
    <PageWidget title={title} width={pageWidth} center={center}>
      <ReadingLayoutWidget
        sidebarWidth={SIDEBAR_WIDTH}
        contentWidth={layoutContentWidth}
        tableOfContents={
          hasTableOfContents ? (
            <TableOfContentsWidget
              items={tableOfContents}
              contentRef={contentRef}
              scrollContainerRef={scrollContainerRef}
              showHeadingTags={showHeadingTags}
            />
          ) : undefined
        }
      >
        <S.ChildrenContent ref={contentRef}>{children}</S.ChildrenContent>
      </ReadingLayoutWidget>
    </PageWidget>
  );
};
namespace S {
  export const ChildrenContent = styled.div`
    min-width: 0;
  `;
}
